(function () {
  if (window.phonedebug == 1) return
  var src = './eruda.js';  //指向eruda,js的目录地址
  let g = window.localStorage.getItem("phonedebug")
  if (g == "1") {
    // var src = 'https://cdn.bootcss.com/eruda/1.3.2/eruda.min.js';
    document.write('<scr' + 'ipt src="' + src + '"></scr' + 'ipt>');
    document.write('<scr' + 'ipt>eruda.init();</scr' + 'ipt>');
    window.phonedebug = 1
  }
})();





import Vue from 'vue'

import router from '../src/route/index'
import store from '../src/store/index'
import installEvent from './api/event'

import CoreNet from './api/net'
//init里面引用了routeHandler
import init from './init'

import layout from './layouts/index'

// import io from './api/socketio'

// import '../src/assets/icons' // svg 图标

import moment from 'moment';
// require('moment/locale/zh-cn');
// moment.locale('zh-cn');
window.moment = moment;//全局引入moment
import axios from 'axios'
window.axios = axios



require('./api/prototype')

import helper from './helper/index'
import channel from '../src/store/channel'



const app = {

  Setting: {
    core: {}
  }
}

app.Vue = Vue

//路由接口
app.router = router
app.pushRoutes = router.pushRoutes
app.routes = router.routes

//状态接口
app.store = store.instance
app.addStore = store.addStore

//运行配置
app.config = window._project || {}

app.__FX_INIT = []

//布局接口
app.layout = layout

//实时通信接口
// app.io = io

//挂载子系统
app.mount = ({ routes, store, init }) => {
  // 载入vue-router
  if (routes) {
    if (Array.isArray(routes)) app.pushRoutes(routes)
    else if (typeof routes === 'function') app.pushRoutes(routes(app))
  }
  // 载入vuex
  if (store) {
    const { name, module } = (typeof store === "function") ? store(app) : store
    app.addStore(name, module)
  }
  if (init) {
    app.__FX_INIT.push(init);
  }
}

helper.loadHelpers(app)
//api接口



app.store.$app = app
Vue.prototype.$app = app
// Vue.prototype.$curl = HTTP.curl
Vue.config.productionTip = false
window.$app = app

//声明可被重写的组件
app.Override = {
  'relogin': ''
};


app.safelogout = () => {
  app.store.dispatch("core/logout");
}


// function supplysession(sec) {

//   setTimeout(() => {
//     app.curl.get("/api/core/system/supplySession").finally(() => {
//       supplysession(sec)
//     })
//   }, sec * 1000)

// }



app.start = async (selector = "#app") => {

  app.event = installEvent({})

  Vue.prototype.$listen = function (channel, fn) {
    let fd = app.event.on(channel, fn)
    this.$once("hook:beforeDestroy", () => {
      fd.dispose()
    })
  }

  await init.initFX_DYNAMIC()
  document.title = "正在加载..."

  await CoreNet.exec(app)


  Vue.prototype.$curl = app.curl



  // try {

  //   let { sso_url, keeplive, ...data } = window.QueryDict;


  //   if (data.jwt != undefined || sso_url) {
  //     sso_url = sso_url || "/api/public/core/sso_from"
  //     await curl.get(sso_url, data)
  //   }

  //   //如果是保活模式那就是1200s一次补充session
  //   if (keeplive == "true") {
  //     supplysession(20 * 60)
  //   }

  // } catch (error) {
  //   console.error("app 单点登录", error);
  // }

  //如果用户处于非正常可用状态,不执行onStart
  if (app.CORE_PROFILE.user.status === '1') {
    if (app.onStart) {
      try {
        await app.onStart()
      } catch (error) {
        console.error("app onStart 执行报错", error);
      }
    }
  }


  app.el = selector;

  await init.start(app).then(() => {

    // if (window.QueryDict && window.QueryDict["tabtitle"]) {
    //   document.title = window.QueryDict["tabtitle"]
    // } else
    document.title = app.ProjSetting.title

    if (app.store.state.core.user.declareinfo) {


    }
    else if (app.store.state.core.user.authinfo && app.store.state.core.user.authinfo.authleftdays < 10 && app.store.state.core.user.authinfo.authleftdays > 0) {
      //授权时间快到了
      if (app.$vue.$route.name !== "core-auth") {
        app.$vue.$Modal.confirm({
          title: "授权时间即将过期",
          content: `授权时间仅剩:${app.store.state.core.user.authinfo.authleftdays}天,是否马上前往授权界面授权`,
          onOk() {
            app.$vue.$router.push({ name: "core-auth" })
          }
        })
      }
    }


    return app.hookexec(app, "onInit")
    // fxImport("./web/config/core/hook.config.js").then(res => {
    //   if (res && typeof res.onIndex == "function") return res.onIndex()
    // })

  }).catch(err => {


    console.error(err);
    // if (app.emitDirection !== true) {
    //     app.emitDirection = true
    //     sessionStorage.setItem("error", err.stack || err.message)
    //     location.href = "/static/error/error.html";
    // }
  });
};

if (navigator.windowControlsOverlay) {
  navigator.windowControlsOverlay.addEventListener('geometrychange', () => {
    document.body.classList.toggle('controlTitleBar', navigator.windowControlsOverlay.visible);
  });
}


export default app
